import { RouteRecordRaw } from "vue-router";

export const assignmentRoutes: Array<RouteRecordRaw> = [
  {
    path: "/assignments/:id/edit",
    name: "AssignmentEdit",
    component: () => import("../views/AssignmentEdit.vue"),
    meta: {
      requiresAuth: true,
      requiredModule: "assignment",
      requiredRight: "viewUI",
    },
  },
];
